import React from "react";

import { t } from "app/utils";

import QueryStringSwitch, { QueryStringSwitchState } from "components/filters/QueryStringSwitch";

const queryKey = "c";
export const communityOptions = {
  connections: t("Following"),
  connected: t("Followers"),
  suggestions: t("Suggested")
};

const CommunityFilter = () => (
  <QueryStringSwitch
    clearLabel={t("All Organization")}
    initialOpen
    options={communityOptions}
    queryKey={queryKey}
    title={t("Community")}
  />
);

export const CommunityFilterState = () => (
  <QueryStringSwitchState options={communityOptions} queryKey={queryKey} />
);

export default CommunityFilter;
